function normalizeId(value) {
  if (value === null || value === undefined) return null;
  const normalized = String(value).trim();
  return normalized || null;
}

export function getDoctorIdentityIds(doctor) {
  const candidates = [
    doctor?.id,
    doctor?._id,
    doctor?.doctorId,
    doctor?.pgId,
    doctor?.userId,
    doctor?.raw?.id,
    doctor?.raw?._id,
    doctor?.raw?.doctorId,
    doctor?.raw?.pgId,
    doctor?.raw?.userId,
  ];

  return [...new Set(candidates.map(normalizeId).filter(Boolean))];
}

export function isLiveHost(hostDoctorId, doctor) {
  const normalizedHostId = normalizeId(hostDoctorId);
  return Boolean(
    normalizedHostId && getDoctorIdentityIds(doctor).includes(normalizedHostId)
  );
}

export function normalizeLiveStatus(value) {
  const normalized = String(value || "").trim().toLowerCase();
  if (["started", "live", "active", "ongoing"].includes(normalized)) {
    return "started";
  }
  if (["scheduled", "pending", "idle", "created"].includes(normalized)) {
    return "scheduled";
  }
  if (
    ["ended", "finished", "closed", "cancelled", "canceled"].includes(
      normalized
    )
  ) {
    return "ended";
  }
  return "idle";
}

export function getHostLiveAction(status) {
  const normalized = normalizeLiveStatus(status);
  if (normalized === "started") return "end";
  if (normalized === "ended") return null;
  return "start";
}

export function getViewerLiveAction(connected) {
  return connected ? "leave" : "join";
}

export async function startThenJoin(start, join) {
  await start();
  return join();
}
